<section class="sv" [ngStyle]="theme" [style.font-family]="settingsData?.font_family || null">
    <aside class="sv-panel">
        <div class="sv-brand">
            <div class="sv-logo" *ngIf="networkLogo"><img [src]="networkLogo" alt=""></div>
            <div class="sv-brand-copy">
                <h2 class="sv-brand-name" *ngIf="networkName">{{ networkName }}</h2>
                <p class="sv-brand-line">One free account for everything on {{ networkName || 'this network' }}.</p>
            </div>
        </div>

        <nav class="sv-features" aria-label="What your account includes">
            <a class="sv-feature" *ngFor="let card of features; trackBy: trackByLink" [routerLink]="card.link">
                <span class="sv-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="card.icon"></path></svg>
                </span>
                <span class="sv-feature-copy">
                    <span class="sv-feature-title">{{ card.title }}</span>
                    <span class="sv-feature-text">{{ card.text }}</span>
                </span>
                <svg class="sv-feature-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>
            </a>
        </nav>
    </aside>

    <main class="sv-main">
        <form class="sv-form sv-card" [formGroup]="form" (ngSubmit)="submitted.emit()" novalidate>
            <div class="sv-head">
                <div>
                    <h1 class="sv-title">Create your account</h1>
                    <p class="sv-sub" *ngIf="networkName">Join {{ networkName }}</p>
                </div>
                <p class="sv-signin">Have an account? <button type="button" class="sv-link" (click)="signIn.emit()">Sign in</button></p>
            </div>

            <div class="sv-row">
                <label class="sv-field">
                    <span class="sv-field-label">First name <span class="sv-req" aria-hidden="true">*</span></span>
                    <span class="sv-input" [class.is-invalid]="showError('firstName')">
                        <svg class="sv-input-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="icons.user"></path></svg>
                        <input formControlName="firstName" name="firstName" maxlength="35" allowValues isInputType="alphaNumeric" autocomplete="given-name" placeholder="First name" required>
                    </span>
                    <span class="sv-error" *ngIf="showError('firstName')">Please enter first name</span>
                </label>
                <label class="sv-field">
                    <span class="sv-field-label">Last name <span class="sv-req" aria-hidden="true">*</span></span>
                    <span class="sv-input" [class.is-invalid]="showError('lastName')">
                        <svg class="sv-input-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="icons.user"></path></svg>
                        <input formControlName="lastName" name="lastName" maxlength="35" allowValues isInputType="alphaNumeric" autocomplete="family-name" placeholder="Last name" required>
                    </span>
                    <span class="sv-error" *ngIf="showError('lastName')">Please enter last name</span>
                </label>
            </div>

            <label class="sv-field">
                <span class="sv-field-label">Email address <span class="sv-req" aria-hidden="true">*</span></span>
                <span class="sv-input" [class.is-invalid]="showError('email')">
                    <svg class="sv-input-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="icons.mail"></path></svg>
                    <input type="email" formControlName="email" name="email" maxlength="255" autocomplete="email" placeholder="you@example.com" required>
                </span>
                <span class="sv-error" *ngIf="showError('email')">{{ hasError('email', 'required') ? 'Please enter email' : 'Please enter valid email' }}</span>
            </label>

            <div class="sv-row">
                <label class="sv-field">
                    <span class="sv-field-label">Password <span class="sv-req" aria-hidden="true">*</span></span>
                    <span class="sv-input" [class.is-invalid]="showError('password')">
                        <svg class="sv-input-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="icons.lock"></path></svg>
                        <input [type]="showPassword ? 'text' : 'password'" formControlName="password" name="password" autocomplete="new-password" placeholder="Create a password" (input)="passwordInput.emit($event)" required>
                        <button type="button" class="sv-eye" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                            <svg viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="showPassword ? icons.eyeOff : icons.eye"></path></svg>
                        </button>
                    </span>
                    <span class="sv-error" *ngIf="showError('password') && hasError('password', 'required')">Please enter password</span>
                </label>
                <label class="sv-field">
                    <span class="sv-field-label">Confirm password <span class="sv-req" aria-hidden="true">*</span></span>
                    <span class="sv-input" [class.is-invalid]="showError('confirmPassword')">
                        <svg class="sv-input-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="icons.lock"></path></svg>
                        <input [type]="showConfirm ? 'text' : 'password'" formControlName="confirmPassword" name="confirmPassword" autocomplete="new-password" placeholder="Repeat password" required>
                        <button type="button" class="sv-eye" (click)="showConfirm = !showConfirm" [attr.aria-label]="showConfirm ? 'Hide password' : 'Show password'">
                            <svg viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="showConfirm ? icons.eyeOff : icons.eye"></path></svg>
                        </button>
                    </span>
                    <span class="sv-error" *ngIf="showError('confirmPassword')">{{ hasError('confirmPassword', 'required') ? 'Please enter confirm password' : 'Passwords must match' }}</span>
                </label>
            </div>
            <ul class="sv-rules" aria-label="Password requirements">
                <li *ngFor="let rule of passwordRules" [class.is-met]="rule.met">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="rule.met ? icons.check : icons.dot"></path></svg>{{ rule.label }}
                </li>
            </ul>

            <div class="sv-row sv-row--end">
                <label class="sv-field">
                    <span class="sv-field-label">Referral code <span class="sv-optional">(optional)</span></span>
                    <span class="sv-input">
                        <svg class="sv-input-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="icons.tag"></path></svg>
                        <input formControlName="referral_code" name="referral_code" maxlength="35" allowValues placeholder="Enter code">
                    </span>
                </label>
                <label class="sv-agree">
                    <input type="checkbox" [checked]="isAgrees" (change)="agreeChange.emit($any($event.target).checked)">
                    <span>I agree to the <strong class="sv-terms">terms and conditions</strong></span>
                </label>
            </div>

            <div class="sv-submit-row">
                <re-captcha (resolved)="captchaResolved.emit($event)" [siteKey]="captchaKey"></re-captcha>
                <button type="submit" class="sv-submit">Create my account</button>
            </div>
        </form>
    </main>
</section>
